import { DataSource, HorizontalSpacer, Label, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDistancePreferences extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelDistanceCalculations: Label;
    labelLocalMileage: Label;
    labelLookupFailureFallbacks: Label;
    labelStoreMileage: Label;
    labelTimeouts: Label;
    sourceDistanceControl: DataSource;
    switchCreateLocalMileageRecords: Switch;
    switchResortToCityWhenZipFails: Switch;
    switchResortToZipWhenLatLongFails: Switch;
    switchStoreMileage: Switch;
    textboxBillingProfile: Textbox;
    textboxDistanceLookupRetry: Textbox;
    textboxDistanceTimeout: Textbox;
    textboxDistanceUM: Textbox;
    textboxETAProfile: Textbox;
    textboxEmptyMoveProfile: Textbox;
    textboxFuelProfile: Textbox;
    textboxLoadedMoveProfile: Textbox;
    textboxLocalMovementDistance: Textbox;
    textboxLocalOrderDIstance: Textbox;
    textboxPayProfile: Textbox;
    textboxPayUsing: Textbox;
    textboxPracticalProfile: Textbox;
    textboxShortestProfile: Textbox;
}
